export enum PrescriptionFulfillmentTypeEnum {
    Medicine = 1,
    LabTest,
    Radiology,
    HospitalProcedure
}
